import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer, Dialog, FormControlLabel, Menu, CardHeader, Slide, MenuItem, Radio, RadioGroup, Button, CircularProgress, AppBar, Toolbar, IconButton, Typography, Divider } from '@material-ui/core'
import { index, destroy } from '../../../store/actions/cotas.action'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaPencilAlt, FaTrash, FaGripHorizontal, FaPlus, FaEyeSlash, FaEye } from 'react-icons/fa'
import { FcFilingCabinet } from 'react-icons/fc'
import { MdMoreHoriz } from 'react-icons/md'
import { Confirm } from '../../components'
import Detail from './detail'
import Fullname from '../../components/Fullname'


export default function CotaPremiada(props) {
    const dispatch = useDispatch()
    const { cotas } = useSelector(state => state.cotasReducer)
    const campaign_id = (props.uid) ? props.uid : null;

    const [isLoad, setLoad] = React.useState(true)
    const [isLoading, setLoading] = React.useState(true)

    const [status, setStatus] = React.useState(1)
    const [view, setView] = React.useState('default')
    const [preView, setPreView] = React.useState('default')
    const [isMenu, setMenu] = React.useState(false)

    const [detail, setDetail] = React.useState({
        id: null,
        open: false
    })

    const [state, setState] = React.useState({
        isDeleted: null,
        menuEl: null,
        confirmEl: null
    })

    React.useEffect(() => {
        _index()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status])

    React.useEffect(() => {
        if(view === 'list-editor' || preView === 'list-editor') {
            _index()
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [view])

    const _index = () => {
        setLoad(true)
        dispatch(index({
            campaign_id: campaign_id,
            status: status,
            editor: view === 'list-editor' ? 'desc' : null
        })).then(() => {
            setLoad(false)
            setLoading(false)
        })
    }

    const handlePage = (page, campaign_id = null, id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                campaign_id: campaign_id,
                uid: id,
                editor: view === 'list-editor' ? 'editor' : null
            }
        }))
    }

    const _destroy = (id) => {
        setState({ isDeleted: id })
        dispatch(destroy(id)).then(res => res && setState({ isDeleted: null }))
    }

    const _detail = (id) => {
        setDetail({
            id: id,
            open: true
        })
    }

    const tamanho = (item) => {
        let tam = item ? item.length : null
        if(tam < 5) {
            return 'h1'
        }

        if(tam < 7) {
            return 'h2'
        }

        if(tam < 9) {
            return 'h3'
        }

        if(tam < 11) {
            return 'h5'
        }

        if(tam > 10) {
            return 'h6'
        }
    }

    const _text = (string) => {
        let text = ""
        for (let index = 0; index < string.length; index++) {
            text = text + "0"
        }

        return text
    }

    const Transition = React.forwardRef((props, ref) => {
        return <Slide direction="up" ref={ref} {...props} />
    })

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Cotas premiadas</Typography>
                    
                    <Button 
                        variant="contained" 
                        size="small" 
                        onClick={() => handlePage('cota-premiada-create', campaign_id)}
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaPlus />}
                    >
                        Cadastrar
                    </Button>
                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
				style={{width: '100%'}}
                onClose={() => setDetail({ id: null, open: false })}
                className="center"
            >   
                <Detail view={view} uid={detail.id} onClose={() => setDetail({ id: null, open: false })}/>
            </Dialog>


            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card-body d-flex justify-content-between">
                        <label className="label-custom m-0 bs-color">{cotas.length.toLocaleString('pt-BR', {style: 'decimal'})} registro(s)</label>
                        
                        <div className="d-flex gap-3">
                            <IconButton className="p-0 bs-color" onClick={() => setMenu(true)}>
                                <FaGripHorizontal size="1.2em" />
                            </IconButton>
                            
                            <IconButton 
                                className="p-0 bs-color" 
                                onClick={() => {
                                    setPreView(view)
                                    setView(view === 'list-editor' ? 'default' : 'list-editor')
                                }}
                            >
                                {view === "list-editor" ?
                                    <FaEye size="1.2em" />
                                :
                                    <FaEyeSlash size="1.2em" />
                                }  
                            </IconButton>
                        </div>
                    </div>

                    <Drawer 
                        anchor="bottom"
                        open={isMenu}
                        onClose={() => setMenu(false)}
                    >
                        <div className="card card-body bs-bg">
                            <label className="fw-bold label-custom bs-color-b"><FaGripHorizontal size={20} className="me-2" />MODOS DE VIZUALIZAÇÃO</label>

                            <div className="mt-3 mb-3">
                                <RadioGroup
                                    name="type"
                                    value={view}
                                    onChange={text => {
                                        setPreView(view)
                                        setView(text.target.value)
                                    }}
                                    className="fw-bold bs-color-b"
                                >
                                    <FormControlLabel value="default" control={<Radio color="primary" />} label="PADRÃO" />
                                    <FormControlLabel value="list-abrev" control={<Radio color="primary" />} label="LISTA ABREVIADA" />
                                    <FormControlLabel value="list-clean" control={<Radio color="primary" />} label="LISTA CLEAN" />
                                    <FormControlLabel value="grid-3" control={<Radio color="primary" />} label="GRID 3" />
                                    <FormControlLabel value="grid-4" control={<Radio color="primary" />} label="GRID 4" />
                                    <FormControlLabel value="grid-title" control={<Radio color="primary" />} label="GRID TÍTULO" />
                                </RadioGroup>
                            </div>
                        </div>
                    </Drawer>

                    <div className="card p-3 mb-2 bs-bg">
                        <div>
                            <RadioGroup
                                row
                                name="type"
                                value={parseInt(status)}
                                onChange={text => setStatus(text.target.value)}
                                className="fw-bold bs-color-b"
                            >
                                <FormControlLabel value={1} control={<Radio color="primary" />} label="TODAS" />
                                <FormControlLabel value={2} control={<Radio color="primary" />} label="DISPONIVEIS" />
                                <FormControlLabel value={3} control={<Radio color="primary" />} label="VENDIDAS" />
                            </RadioGroup>
                        </div>
                    </div>

                    {(isLoad) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                        <>

                        {(cotas.length < 1) &&
                            <div className="card card-body mt-3 bs-bg">
                                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                    <FcFilingCabinet size="70" />
                                    <h6 className="mt-4 text-muted bs-color">Nenhum registro encontrado</h6>
                                </div>
                            </div>
                        }

                        {(cotas.length > 0) &&
                            <>

                            {(view === 'default' || view === 'list-abrev' || view === 'list-clean' || view === 'list-editor') &&
                                <>
                                  {cotas.map((item, index) => (
                                    <div className="card pointer bs-bg list-items" key={index}>
                                        <CardHeader
                                            className={view === 'list-clean' ? "pt-0 pb-0" : "pt-2 pb-2"}
                                            avatar={
                                                <button onClick={() => _detail(item.id)} type="button" className={"position-relative fw-bold btn "+ (item.user_id ? 'btn-secondary' : 'btn-success')}>
                                                    <span className="position-absolute">{item.quota_number}</span>
                                                    <span className="invisible">{_text(item.quota_number)}</span>
                                                </button>
                                            }
                                            title={<>
                                                <div className="d-flex" onClick={() => _detail(item.id)}>
                                                    {view === 'list-editor' && 
                                                        <h6 className="m-0 fw-bold position-relative me-3 bs-color-b">
                                                            <span className="position-absolute">{item.position ? item.position + '%' : ''}</span>
                                                            <span className="invisible">00.00%</span>
                                                        </h6>
                                                    }
                                                    <h6 className="m-0 fw-bold bs-color-b">{item.title ? item.title.substring(0,25) : item.title}</h6>
                                                </div>
                                            </>}
                                            subheader={(view !== 'list-clean' && view !== 'list-editor') && <>
                                                {item.user_id &&
                                                    <>
                                                    <span onClick={() => _detail(item.id)} className="d-block bs-color">{<Fullname fullName={item.user_name ? item.user_name.substring(0,25) : item.user_name} />}</span>
                                                    {(view === 'default') &&
                                                        <small className="bs-color" onClick={() => _detail(item.id)}>{new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(item.time_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(item.time_at))}</small>
                                                    }
                                                    </>
                                                }
                                            </>}
                                            
                                            action={
                                                <h6 className="fw-bold pt-3 pe-3">
                                                    <MdMoreHoriz className="bs-color" id={index} onClick={event => setState({ menuEl: event.currentTarget })} size={28} />
                                                </h6>
                                            }
                                        />

                                        {(Boolean(state.menuEl)) &&
                                            <Menu
                                                anchorEl={state.menuEl}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                TransitionComponent={Transition}
                                                open={(index === parseInt(state.menuEl.id))}
                                                onClose={() => setState({ menuEl: null })}
                                            >
                                                <MenuItem 
                                                    onClick={() => {
                                                        setState({ menuEl: null })
                                                        handlePage('cota-premiada-edit', campaign_id, item.id)
                                                    }}
                                                    className="bs-color-b"
                                                >
                                                    <FaPencilAlt size="1.2em" className="me-4" /> <strong>Editar</strong>
                                                </MenuItem>
                                                
                                                {!item.user_id &&
                                                    <div>
                                                        <Divider />

                                                        <MenuItem 
                                                            onClick={() => setState({ confirmEl: item.id })}
                                                            className="bs-color-b"
                                                        >
                                                            <FaTrash color="#dc3545" size="1.2em" className="me-4" /> <strong>Apagar</strong>
                                                        </MenuItem>
                                                    </div>
                                                }
                                                <div className='mt-3'></div>
                                            </Menu>
                                        }
                                        {(state.confirmEl === item.id) && 
                                            <Confirm
                                                open={(item.id === state.confirmEl)}
                                                onClose={() => setState({ confirmEl: null })}
                                                onConfirm={() => _destroy(item.id)}
                                                title="Tem certeza que deseja remover ?"
                                            />
                                        }
                                    </div>
                                ))}
                                </>
                            }

                            {view === 'grid-3' &&
                                <div className="card card-body bs-bg">
                                    <div className="d-grid-3">
                                        {cotas.map((item, index) => (
                                            <button onClick={() => _detail(item.id)} key={index} type="button" className={!item.user_id ? 'fw-bold btn btn-success m-1' : 'fw-bold btn btn-secondary m-1'}>
                                                {item.quota_number}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            }

                            {view === 'grid-4' &&
                                <div className="card card-body bs-bg">
                                    <div className="d-grid-4">
                                        {cotas.map((item, index) => (
                                            <button onClick={() => _detail(item.id)} key={index} type="button" className={!item.user_id ? 'fw-bold btn btn-success m-1 p-1' : 'fw-bold btn btn-secondary m-1 p-1'}>
                                                {item.quota_number}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            }
                            
                            {view === 'grid-title' &&
                                <div className="card card-body bs-bg">
                                    <div className="row">
                                        {cotas.map((item, index) => (
                                            <div className="col-4 d-flex align-items-end p-2" onClick={() => _detail(item.id)}>
                                                <div key={index} className="w-100 d-flex flex-column justify-content-end align-items-center">
                                                    {item.title ?
                                                    <h6 className={'h-100 text-center mb-1 ' + tamanho(item.title)}><span className="badge bg-dark pointer">{item.title}</span></h6>
                                                    :
                                                    <h6>&nbsp;</h6>
                                                    }
                                                    <button key={index} type="button" className={!item.user_id ? 'fw-bold d-block btn btn-success h-100 w-100' : 'fw-bold d-block btn btn-secondary h-100 w-100'}>
                                                        {item.quota_number}
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            }
                            </>
                        }
                    </>
                    }
                </>
            }
            </div>
        </>
    )
}